import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_bulb_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_bulb_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import rgbw_bulb_settings_no_input from '@devices/settings/device_settings/rgbw_bulb_settings_no_input.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

/**
 * Common configuration shared across all modes to reduce duplication.
 * This bulb uses a single rgbcct:0 component that can switch between rgb and cct modes.
 */
const commonConfig = {
	channels: 1,
	notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
	slider: 'brightness',
	brightness: 0,
	effects: false,
	settings: [
		timer_gen_2,
		schedule_gen_2,
		webhooks_gen_2,
		night_mode_gen_2,
		scripts_gen_2,
		virtual_components,
		networks_gen_2_plus,
		bluetooth_bt_home_control_gen_2,
		app_setting_bulb_rgbw_gen_2,
		share,
		rgbw_bulb_settings_no_input,
	],
};

const colorTempRange = { minValue: 2700, maxValue: 6500 };

export default {
	name: 'ShellyMulticolorBulbGen3',
	friendly_name: 'Multicolor Bulb E27 Gen3',
	family: 'light',
	isPM: true,
	modes: {
		// Main mode - supports both color and white temperature controls
		// color: true enables the Color/White mode switcher in the UI
		rgbcct: {
			...commonConfig,
			color_temp: colorTempRange,
			color: true,
		},
		// RGB mode - active when device is set to color mode (status['rgbcct:0'].mode === 'rgb')
		// Required for ControlSlider to work when get_mode() returns 'rgb'
		// color: true shows color picker controls
		rgb: {
			...commonConfig,
			color: true,
		},
		// CCT mode - active when device is set to white mode (status['rgbcct:0'].mode === 'cct')
		// Required for ControlSlider to work when get_mode() returns 'cct'
		// color_temp enables white temperature controls
		cct: {
			...commonConfig,
			color_temp: colorTempRange,
		},
	},
};
